<template>
  <article class="rounded-2xl border border-[var(--ui-border)] bg-[var(--arad-surface)] p-4">
    <div class="flex items-start justify-between gap-3">
      <div class="min-w-0">
        <div class="flex flex-wrap items-center gap-2">
          <p class="font-semibold">
            {{ comment.status === 'deleted' ? 'دیدگاه حذف شد' : comment.authorName }}
          </p>
          <UBadge
            v-if="comment.authorType === 'doctor'"
            color="primary"
            variant="subtle"
            size="xs"
          >
            پاسخ پزشک
          </UBadge>
        </div>
        <p class="mt-0.5 text-xs text-[var(--ui-text-muted)]">
          {{ faDate(comment.createdAt, 'long') }}
        </p>
      </div>
      <UButton
        v-if="comment.mine && comment.status !== 'deleted'"
        variant="ghost"
        color="error"
        size="xs"
        icon="i-lucide-trash-2"
        @click="$emit('remove', comment.id)"
      />
    </div>
    <p
      v-if="comment.status !== 'deleted'"
      class="mt-3 whitespace-pre-wrap text-[15px] leading-7"
    >
      {{ comment.body }}
    </p>
    <p
      v-else
      class="mt-3 text-sm text-[var(--ui-text-muted)]"
    >
      این دیدگاه حذف شده است.
    </p>
    <div
      v-if="canReply && comment.status !== 'deleted'"
      class="mt-3"
    >
      <UButton
        variant="ghost"
        size="xs"
        icon="i-lucide-corner-up-right"
        @click="$emit('reply', comment.id)"
      >
        پاسخ
      </UButton>
    </div>
    <ul
      v-if="comment.replies?.length"
      class="mt-4 space-y-3 border-s border-[var(--ui-border)] ps-4"
    >
      <li
        v-for="child in comment.replies"
        :key="child.id"
      >
        <BlogCommentCard
          :comment="child"
          :can-reply="canReply"
          @reply="$emit('reply', $event)"
          @remove="$emit('remove', $event)"
        />
      </li>
    </ul>
  </article>
</template>

<script setup lang="ts">
import type { BlogCommentPublic } from '~/types/blog'
import { faDate } from '~/utils/faDate'

defineProps<{
  comment: BlogCommentPublic
  canReply?: boolean
}>()

defineEmits<{
  reply: [id: string]
  remove: [id: string]
}>()
</script>
